import React from 'react';

const Input = ({ label, type = "text", name, value, onChange, required = false, className = "", isTextarea = false }) => {
    return (
        <div className={`input_column ${className}`}>
            {label && <label>{label}</label>}
            {isTextarea ? (
                <textarea
                    name={name}
                    value={value}
                    onChange={onChange}
                    required={required}
                ></textarea>
            ) : (
                <input
                    type={type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    required={required}
                />
            )}
        </div>
    );
};

export default Input;
